'use client';

import cx from 'classix';
import { useAtomValue } from 'jotai';
import dynamic from 'next/dynamic';
import { type ReadonlyURLSearchParams } from 'next/navigation';

import { isMapViewAtom } from '@/features/listing/atoms/is-map-view-atom';
import { type ListingType } from '@/features/listing/types/listing-types';
import { type Place } from '@/features/place/types/place-types';
import calculateCenterFromBbox from '@/features/place/utils/calculate-center-from-bbox';

import styles from './listings-map.module.scss';

const mapLoader = () => <p>A map is loading</p>;

const Map = dynamic(
  () => import('@/features/listing/components/listings-map/map/map-render'), // replace '@components/map' with your component's location
  {
    loading: mapLoader,
    ssr: false, // This line is important. It's what prevents server-side render
  },
);

interface ListingsMapProps {
  searchParams: ReadonlyURLSearchParams;
  listingType: ListingType;
  currentPlace: Place;
}

export default function ListingsMap(props: ListingsMapProps) {
  const {
    currentPlace,
    listingType,
    searchParams,
  } = props;

  const isMapView = useAtomValue(isMapViewAtom);

  const {
    latitude,
    longitude,
  } = calculateCenterFromBbox(currentPlace.bbox);

  return (
    <div className={cx(styles.map, isMapView && styles.map__isActive)}>
      <Map
        listingType={listingType}
        searchParams={searchParams}
        currentPlace={currentPlace}
        coordinates={{
          lat: latitude,
          lng: longitude,
        }}
      />
    </div>
  );
}
